angular
    .module('policy.service', [])
    .service('policyService', ['$rootScope', '$filter', '$q', 'popupService', 'httpService', 'commonConst', '$location',
        function ($rootScope, $filter, $q, popupService, httpService, commonConst, $location) {
            return {
                getPolicySummary: getPolicySummary,
                getPolicyDetails: getPolicyDetails,
                isMultiPolicy: isMultiPolicy,
                getPolicyPayment: getPolicyPayment,
                isActivePolicy: isActivePolicy,
                openPoliciesClaimsSearchForVic: openPoliciesClaimsSearchForVic,
                getSelectPolicyAction: getSelectPolicyAction,
                getSelectClaimAction: getSelectClaimAction,
                getSelectPolicyActionByClaim: getSelectPolicyActionByClaim,
                getIncludeCOVPolicy: getIncludeCOVPolicy,
                getPolicyDetailForVic: getPolicyDetailForVic,
                getPageWording: getPageWording
            };
            // Set multiple policy
            var hasMultiPolicy = false;
            function isMultiPolicy() {
                return hasMultiPolicy;
            }

            // Call this function when user choose a policy
            var selectPolicyAction;
            function getSelectPolicyAction() {
                return selectPolicyAction;
            }

            // Call this fucntion when user choose a claim
            var selectClaimAction;
            function getSelectClaimAction() {
                return selectClaimAction;
            }

            // Call this function when user choose a policy in CLAIM search result
            var selectPolicyActionByClaim;
            function getSelectPolicyActionByClaim() {
                return selectPolicyActionByClaim;
            }

            //Fix wording for upload document so it's clearer to user when upload document vs when search in my claim
            var pageWording;
            function getPageWording() {
                return pageWording;
            }
            // This variable is used to add condition to Policy query statement
            // Source = 'Upload' => includeCOVPolicy = 1
            // Otherwise => includeCOVPolicy = 0
            var includeCOVPolicy = 0;
            function getIncludeCOVPolicy() {
                return includeCOVPolicy;
            }

            function openPoliciesClaimsSearchForVic(source) {
                // Clear page history
                // $rootScope.pageNavigationHistory.policy = null;
                // $rootScope.pageNavigationHistory.claim = null;
                $rootScope.pageNavigationHistory.searchKey = null;
                $rootScope.pageNavigationHistory.filterJurisdiction  = null; 
                $rootScope.pageNavigationHistory.claimPolicySearchRowPerPage  = null; 
                $rootScope.searchPageSelected = 1;

                if (source === 'My Claims') {
                    // Define handler when user chooses a policy
                    selectPolicyAction = function (policy) {
                        $rootScope.pageNavigationHistory.policy = policy;
                        sessionStorage.RecentlySelectedType = $filter('enstr64')(commonConst.POLICY);
                        sessionStorage.Policy = $filter('enstr64')(JSON.stringify(policy));

                        //Flag flow not access vic claim summary via claim detail
                        $rootScope.pageNavigationHistory.statsWPNumber = null;

                        $location.path("/claim-summary-vic");
                    }

                    // Define handler when user chooses a claim
                    selectClaimAction = function (claim) {
                        $rootScope.pageNavigationHistory.claim = claim;
                        // sessionStorage.RecentlySelectedType = $filter('enstr64')(commonConst.CLAIM);
                        // sessionStorage.Claim = $filter('enstr64')(JSON.stringify(claim));
                        $location.path("/claim-details-vic");
                    }

                    // Define handler when user chooses a policy in CLAIM search result
                    selectPolicyActionByClaim = function (claim) {
                        getPolicyDetailForVic(claim.EmployerId).then(function (response) {
                            var policy = response;

                            sessionStorage.RecentlySelectedType = $filter('enstr64')(commonConst.POLICY);
                            sessionStorage.Policy = $filter('enstr64')(JSON.stringify(policy));
                            $rootScope.pageNavigationHistory.claim = null;
                            $rootScope.pageNavigationHistory.policy = policy;
                            $location.path("/claim-summary-vic");
                        });

                        
                    }

                    // Set query condition
                    includeCOVPolicy = 0;

                    pageWording = {
                        pageTitle: null,
                        searchClaimDescription: 'Search by Claim',
                        searchPolicyDescription: 'Search by Policy',
                        searchClaimNote: 'Enter the search criteria to retrieve claims data.',
                        pageInstruction: null,
                    }
                } else if (source === 'Upload') {
                    // Define handler when user chooses a policy
                    selectPolicyAction = function (policy) {
                        $rootScope.pageNavigationHistory.claim = null;
                        $rootScope.pageNavigationHistory.policy = policy;
                        $location.path("/upload-document");
                    }

                    // Define handler when user chooses a policy in CLAIM search result
                    selectPolicyActionByClaim = function (claim) {
                        getPolicyDetailForVic(claim.EmployerId).then(function (response) {
                            var policy = response;

                            // Standardize Policy fields
                            if (policy.EmployerName && !policy.CompanyName) {
                                policy.CompanyName = policy.EmployerName;
                            }
                            if (policy.PolicyStatus && !policy.StatusCode) {
                                policy.StatusCode = policy.PolicyStatus;
                            }

                            $rootScope.pageNavigationHistory.claim = null;
                            $rootScope.pageNavigationHistory.policy = policy;
                            $location.path("/upload-document");
                        });
                    }

                    // Define handler when user chooses a claim
                    selectClaimAction = function (claim) {
                        // $rootScope.pageNavigationHistory.claim = claim;
                        // $rootScope.pageNavigationHistory.policy = null;
                        $location.path("/upload-document");
                    }

                    // Set query condition
                    includeCOVPolicy = 1;

                    pageWording = {
                        pageTitle: null,
                        searchClaimDescription: 'Upload document(s) by claim',
                        searchPolicyDescription: 'Upload document(s) by policy',
                        searchClaimNote: 'Enter the search criteria to find the claim to attach document(s).',
                        pageInstruction: 'Please identify the claim or policy you would like to upload your document(s) to:',
                    }
                }

                $rootScope.navigate('/policy-claim-search');
            }

            function initPageNumbers(pageCount) {
                var pageList = [];
                for (var index = 1; index <= pageCount; index++) {
                    pageList.push(index);
                }

                return pageList;
            }

            function getPolicySummary(searchTerm, page, limit) {
                return getPolicies("api/policies/viewpolicysummary", searchTerm, page, limit);
            }

            function getPolicies(api, searchTerm, page, limit, orderBy, includeCOVPolicy) {
                if (searchTerm === null || searchTerm === undefined) {
                    searchTerm = '';
                }

                var def = $q.defer(),
                    apiTarget = api,
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        RowsPerPage: limit || commonConst.ROWS_PER_PAGE, // default is 10
                        PageNumber: page || 1, // default is firt page
                        Keyword: searchTerm,
                        OrderByDesc: orderBy,
                        IncludeCOVPolicy: includeCOVPolicy
                    });

                httpService.httpRequest(apiTarget, values).then(function (result) {
                    if (result !== false) {
                        if (result === "logout") {
                            $rootScope.userLogout();
                        }
                        var response = angular.fromJson($filter('decstr64')(result));
                        if (response.Policies == null || response.Policies == undefined) {
                            response.Policies = response.PolicyList;
                        }
                        def.resolve(response);
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            };

            function getPolicyDetails(policyId) {
                var def = $q.defer(),
                    apiTarget = "api/policies/viewpolicydetail",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        PolicyId: policyId
                    });

                httpService.httpRequest(apiTarget, values).then(function (data) {  // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data)); // PolicyDetails
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            };

            function getPolicyDetailForVic(policyId) {
                var def = $q.defer(),
                    apiTarget = "api/vicpolicies/getvicpolicydetail",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        PolicyId: policyId
                    });

                httpService.httpRequest(apiTarget, values).then(function (data) {  // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data)); // VicPolicyResult
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            };

            function isActivePolicy(policyNumber) {
                var def = $q.defer(),
                    APITarget = "api/policies/getpolicystatus",
                    Values = JSON.stringify({
                        PolicyNumber: policyNumber
                    });

                httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
                    if (data !== false) {
                        def.resolve(angular.fromJson(data)); // PolicyPayment
                    } else {
                        def.reject();
                    }
                });
                return def.promise;
            };
            function getPolicyPayment(policyId, instalmentNo) {
                var def = $q.defer(),
                    apiTarget = "api/policies/getpaymentoptions",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        PolicyId: policyId
                    });

                httpService.httpRequest(apiTarget, values).then(function (data) {  // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data)); // PolicyPayment
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            };
        }]);
